import { ISchedule, IMagicBoxSchedule, ICsvToJson, IRewardListItem } from '../model';

export enum EMagicBoxDropDownOptions {
	CREATE = 'create',
	REMOVE = 'remove'
}

export enum EApiResponseStatus {
	SUCCESS = 'success',
	ERROR = 'error'
}

export const actionOptions = [
	{ label: 'Add Schedule', id: 'create' },
	{ label: 'Remove Schedule', id: 'remove' }
];

export const toInteger = (num: string): number => {
	return parseInt(num, 10);
};

export const prepareMagicBoxSchedule = (jsonData: ICsvToJson[]): IMagicBoxSchedule => {
	const magicBoxSchedule: IMagicBoxSchedule = {
		schedules: {}
	};

	for (let i: number = 0; i < jsonData.length; i += 1) {
		const { scheduleId } = jsonData[i];
		const rewardList: IRewardListItem[] = [];
		let k: number = 1;
		while (jsonData[i][`randomReward_${k}`]) {
			rewardList.push(JSON.parse(jsonData[i][`randomReward_${k}`]));
			k += 1;
		}
		const schedule: ISchedule = {
			segmentList: JSON.parse(jsonData[i].segmentList),
			priority: toInteger(jsonData[i].priority),
			rechargeTimeInMin: toInteger(jsonData[i].rechargeTimeInMin),
			firstTimeReward: JSON.parse(jsonData[i].firstTimeReward),
			rewardList
		};
		if (jsonData[i].appVersionRange) {
			schedule.appVersionRange = JSON.parse(jsonData[i].appVersionRange);
		}
		magicBoxSchedule.schedules[scheduleId] = schedule;
	}
	return magicBoxSchedule;
};
